import React from 'react'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { getIntegrationConfig } from '../integrationConfig'
import cx from 'classnames'
import Styles from './IntegrationButton.module.scss'

interface Props {
  integration: string
  selectedBlogPlatform?: ExternalIntegrationEnum | 'generic'
  onPress: () => void
}

export const IntegrationButton: React.FC<Props> = ({ integration, selectedBlogPlatform, onPress }) => {
  const config = getIntegrationConfig(integration, selectedBlogPlatform)

  if (!config) return null

  const { provider, displayName, icon: IconComponent } = config

  const buttonClass = cx(Styles.button, {
    [Styles.linkedin]: provider === ExternalIntegrationEnum.LinkedIn,
    [Styles.facebook]: provider === ExternalIntegrationEnum.Facebook,
    [Styles.instagram]: provider === ExternalIntegrationEnum.Instagram,
    [Styles.twitter]: provider === ExternalIntegrationEnum.X,
    [Styles.youtube]: provider === ExternalIntegrationEnum.YouTube,
    [Styles.tiktok]: provider === ExternalIntegrationEnum.TikTok,
    [Styles.mailchimp]: provider === ExternalIntegrationEnum.Mailchimp,
    [Styles.wordpress]: provider === ExternalIntegrationEnum.WordPress,
    [Styles.gohighlevel]: provider === ExternalIntegrationEnum.GoHighLevel,
    [Styles.google]: provider === ExternalIntegrationEnum.Google,
    [Styles.metaads]: provider === ExternalIntegrationEnum.MetaAds,
  })

  return (
    <button className={buttonClass} onClick={onPress}>
      <IconComponent size={24} />
      <span>Connect {displayName}</span>
    </button>
  )
}
